import React, {useEffect, useState} from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import Profile from "../../components/Profile";
import {useDispatch, useSelector} from "react-redux";
import {getBuatSoal, updateJudulBuatSoal, tambahSoal, hapusPertanyaan} from "../../features/buatSoalSlice";
import Button from "../../components/Button";
import {updateStateBuatSoal} from "../../features/buatSoalSlice";
import {updateStateMonitorKelas} from "../../features/monitorKelasSlice";
import searchIcon from "../../assets/icons/search-icon.svg";
import trash from "../../assets/icons/trashRed.svg";
import AlertModal from "../../components/AlertModal";

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

const DEFAULT_PILIHAN = [
    { label: 'Selalu', nilai: 4 },
    { label: 'Sering', nilai: 3 },
    { label: 'Kadang-kadang', nilai: 2 },
    { label: 'Tidak Pernah', nilai: 1 },
]

function BuatPertanyaanModal({ isOpen, onClose, onSave,isLoading,getBuatSoal }) {
    const [pertanyaan, setPertanyaan] = useState('')
    const [pilihan, setPilihan] = useState(DEFAULT_PILIHAN.map(p => ({ ...p })))

    function handleChangePilihan(index, field, value) {
        setPilihan(prev => {
            const updated = [...prev]
            updated[index] = { ...updated[index], [field]: field === 'nilai' ? Number(value) : value }
            return updated
        })
    }

    function handleDeletePilihan(index) {
        setPilihan(prev => prev.filter((_, i) => i !== index))
    }

    function handleTambahPilihan() {
        setPilihan(prev => [...prev, { label: '', nilai: 0 }])
    }

    function handleSave() {
        onSave({ question: pertanyaan, choices: pilihan })
        setPertanyaan('')
        setPilihan(DEFAULT_PILIHAN.map(p => ({ ...p })))

    }

    function handleClose() {
        setPertanyaan('')
        setPilihan(DEFAULT_PILIHAN.map(p => ({ ...p })))
        onClose()
    }

    if (!isOpen) return null

    return (
        <div
            style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
            }}
            onClick={handleClose}
        >
            <div
                style={{
                    background: '#fff', borderRadius: 12, width: 640,
                    boxShadow: '0px 8px 20px rgba(0,0,0,0.12)',
                    display: 'flex', flexDirection: 'column', maxHeight: '90vh', overflow: 'hidden',
                    fontFamily: 'Poppins, sans-serif',
                }}
                onClick={e => e.stopPropagation()}
            >
                {/* Header */}
                <div style={{ padding: '24px 28px 16px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <div>
                        <p style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#0F172A' }}>Buat Pertanyaan</p>
                        <p style={{ margin: '4px 0 0', fontSize: 13, color: '#94A3B8' }}>
                            Isi teks pertanyaan dan atur nilai tiap pilihan jawaban
                        </p>
                    </div>
                    <button
                        onClick={handleClose}
                        style={{
                            background: 'none', border: 'none', cursor: 'pointer',
                            width: 32, height: 32, display: 'flex', alignItems: 'center',
                            justifyContent: 'center', color: '#64748B', fontSize: 18, flexShrink: 0,
                        }}
                    >
                        ✕
                    </button>
                </div>

                <div style={{ height: 1, background: '#E2E8F0' }} />

                {/* Body */}
                <div style={{ padding: '20px 28px', overflowY: 'auto', flex: 1 }}>

                    {/* Teks Pertanyaan */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                        <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: '#0F172A' }}>Teks Pertanyaan</p>
                        <span style={{
                            background: '#3661EB', borderRadius: 20, padding: '4px 14px',
                            fontSize: 13, fontWeight: 600, color: '#fff',
                        }}>
                            Skala / Frekuensi
                        </span>
                    </div>

                    <div style={{
                        background: '#F8FAFC', border: '1.5px solid #E2E8F0', borderRadius: 10,
                        height: 44, display: 'flex', alignItems: 'center', padding: '0 16px', marginBottom: 20,
                    }}>
                        <input
                            type="text"
                            placeholder="Contoh: Evaluasi Kinerja Guru Semester Ganjil 2025/2026"
                            value={pertanyaan}
                            onChange={e => setPertanyaan(e.target.value)}
                            style={{
                                border: 'none', outline: 'none', background: 'transparent',
                                fontSize: 13, color: '#1E293B', width: '100%', fontFamily: 'Poppins, sans-serif',
                            }}
                        />
                    </div>

                    <div style={{ height: 1, background: '#F1F5F9', marginBottom: 16 }} />

                    {/* Pilihan Jawaban */}
                    <p style={{ margin: '0 0 4px', fontSize: 13, fontWeight: 600, color: '#0F172A' }}>Pilihan Jawaban</p>
                    <p style={{ margin: '0 0 12px', fontSize: 12, color: '#94A3B8' }}>
                        Atur label dan nilai (poin) untuk setiap pilihan
                    </p>

                    {/* Table header */}
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        background: '#F8FAFC', borderRadius: 6, padding: '6px 10px', marginBottom: 4,
                    }}>
                        <span style={{ width: 36, fontSize: 11, fontWeight: 500, color: '#94A3B8', flexShrink: 0 }}>Pilihan</span>
                        <span style={{ flex: 1, fontSize: 11, fontWeight: 500, color: '#94A3B8' }}>Label Jawaban</span>
                        <span style={{ width: 50, fontSize: 11, fontWeight: 500, color: '#94A3B8', textAlign: 'center' }}>Nilai</span>
                        <span style={{ width: 20 }} />
                    </div>

                    <div style={{ height: 1, background: '#F8FAFC', marginBottom: 4 }} />

                    {/* Rows */}
                    {pilihan.map((item, i) => (
                        <div key={i}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0' }}>
                                {/* Letter badge */}
                                <div style={{
                                    width: 36, height: 36, background: '#F1F5F9', borderRadius: 8,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                }}>
                                    <span style={{ fontSize: 14, fontWeight: 700, color: '#475569' }}>
                                        {LETTERS[i] ?? i + 1}
                                    </span>
                                </div>

                                {/* Label input */}
                                <div style={{
                                    flex: 1, height: 36, background: '#fff',
                                    border: '1.5px solid #E2E8F0', borderRadius: 8,
                                    display: 'flex', alignItems: 'center', padding: '0 12px',
                                }}>
                                    <input
                                        type="text"
                                        value={item.label}
                                        onChange={e => handleChangePilihan(i, 'label', e.target.value)}
                                        style={{
                                            border: 'none', outline: 'none', background: 'transparent',
                                            fontSize: 14, fontWeight: 500, color: '#1E293B',
                                            width: '100%', fontFamily: 'Poppins, sans-serif',
                                        }}
                                    />
                                </div>

                                {/* Nilai input */}
                                <div style={{
                                    width: 50, height: 36, background: '#fff',
                                    border: '1.5px solid #E2E8F0', borderRadius: 8,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>
                                    <input
                                        type="number"
                                        value={item.nilai}
                                        onChange={e => handleChangePilihan(i, 'nilai', e.target.value)}
                                        style={{
                                            border: 'none', outline: 'none', background: 'transparent',
                                            fontSize: 14, fontWeight: 700, color: '#0F172A',
                                            width: '100%', textAlign: 'center', fontFamily: 'Poppins, sans-serif',
                                        }}
                                    />
                                </div>

                                {/* Delete */}
                                <button
                                    onClick={() => handleDeletePilihan(i)}
                                    style={{
                                        width: 20, background: 'none', border: 'none',
                                        cursor: 'pointer', color: '#D1D5DB', fontSize: 16,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                            <div style={{ height: 1, background: '#F8FAFC' }} />
                        </div>
                    ))}

                    {/* Tambah pilihan */}
                    <div
                        onClick={handleTambahPilihan}
                        style={{
                            background: '#F8FAFC', border: '1.5px solid #3B82F6', borderRadius: 8,
                            height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer', marginTop: 8,
                        }}
                    >
                        <span style={{ fontSize: 12, fontWeight: 600, color: '#3B82F6' }}>+ Tambah pilihan lain</span>
                    </div>
                </div>

                {/* Footer */}
                <div style={{ height: 1, background: '#E2E8F0' }} />
                <div style={{
                    background: '#F8FAFC', padding: '12px 28px',
                    display: 'flex', justifyContent: 'flex-end', gap: 12,
                }}>
                    <button
                        onClick={handleClose}
                        style={{
                            height: 40, padding: '0 28px', background: '#fff',
                            border: '1.5px solid #E2E8F0', borderRadius: 10,
                            fontSize: 14, fontWeight: 500, color: '#64748B',
                            cursor: 'pointer', fontFamily: 'Poppins, sans-serif',
                        }}
                    >
                        Batal
                    </button>
                    <button
                        onClick={handleSave}
                        style={{
                            height: 40, padding: '0 28px', background: '#3661EB',
                            border: 'none', borderRadius: 10,
                            fontSize: 14, fontWeight: 600, color: '#fff',
                            cursor: 'pointer', fontFamily: 'Poppins, sans-serif',
                        }}
                    >
                        {

                            isLoading ? "loading": "Simpan Soal"

                        }


                    </button>
                </div>
            </div>
        </div>
    )
}


function BuatSoal() {

    const {
        isLoading,
        form,
        judul,
        isLoadingTambahSoal,
    } = useSelector(state => state.buatSoalSlice)

    const [alertModalDelete, setAlertModalDelete] = useState(false)
    const dispatch = useDispatch()

    const [showModal, setShowModal] = useState(false)
    const [idUserToDelete, setIdUserToDelete] = useState(null)

    useEffect(() => {
        dispatch(getBuatSoal({}))
    }, []);

    function handleSearch() {
        dispatch(updateJudulBuatSoal({ "nama_form": judul }))
    }

    async function handleSimpanSoal({ question, choices }) {

        await dispatch(tambahSoal({ question, choices }))
        dispatch(getBuatSoal({}))
        if(!isLoadingTambahSoal) {
            setShowModal(false)
        }

    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar/>
            <div className='karyawan'>

                <div className='search-and-profile'>
                    <div className='wrap-search'></div>
                    <Profile/>
                </div>

                <BuatPertanyaanModal
                    isOpen={showModal}
                    onClose={() => setShowModal(false)}
                    onSave={handleSimpanSoal}
                    isLoading={isLoadingTambahSoal}
                    getBuatSoal={()=>         dispatch(getBuatSoal({}))}
                />

                {alertModalDelete && <AlertModal
                    heading={'Hapus Pertanyaan'}
                    message={'Apakah anda yakin ingin menghapus soal ini?'}
                    onCancel={() => setAlertModalDelete(false)}
                    onConfirm={() =>       dispatch(hapusPertanyaan(idUserToDelete)).then((res) => {
                        if (res.meta.requestStatus === 'fulfilled') dispatch(getBuatSoal({}))
                        setAlertModalDelete(false)
                        setIdUserToDelete(null)
                    })}
                />}

                <div className='title-btn'>
                    <h1>Monitor Kelas</h1>

                </div>

                {
                    isLoading ? <></> :
                        <div style={{ display: 'flex', gap: 24 }}>

                            {/* Left Card - Form */}
                            <div style={{
                                borderRadius: 16, overflow: 'hidden'
                                , width: 700, flexShrink: 0, padding: '28px', border: '1px solid #E2E8F0',
                            }}>
                                <h3 style={{ margin: '0 0 8px', fontSize: 17, fontWeight: 500, color: '#1E293B' }}>Detail Evaluasi</h3>



                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                                    <p style={{ margin: '0 0 8px', fontSize: 12, fontWeight: 500, color: '#64748B' }}>Judul Evaluasi</p>
                                    <Button
                                        style={{ width: "56px", height: "22px", fontSize: "12px",fontFamily: 'Poppins, sans-serif', }}
                                        text={'Ubah'}
                                        onClick={handleSearch}
                                    />
                                </div>
                                <div style={{
                                    background: '#F8FAFC', border: '1.5px solid #E2E8F0', borderRadius: 10,
                                    height: 44, display: 'flex', alignItems: 'center', padding: '0 16px', marginBottom: 24,
                                }}>
                                    <input
                                        type="text"
                                        placeholder="Contoh: Evaluasi Kinerja Guru Semester Ganjil 2025/2026"
                                        value={judul}
                                        onChange={(e) => dispatch(updateStateBuatSoal({ name: 'judul', value: e.target.value }))}
                                        style={{
                                            border: 'none', outline: 'none', background: 'transparent',
                                            fontSize: 13, color: '#94A3B8', width: '100%', fontFamily: 'Poppins, sans-serif',
                                        }}
                                    />
                                </div>

                                <div style={{ height: 1, background: '#E2E8F0', marginBottom: 16 }} />

                                <h4 style={{ margin: '0 0 16px', fontSize: 14, fontWeight: 500, color: '#1E293B' }}>Daftar Pertanyaan Evaluasi</h4>


                                <Questions questions={form.form.questions} onDelete={(id) => {
                                    setAlertModalDelete(true)
                                    setIdUserToDelete(id)
                                }}/>

                                {/* Add Question Button */}
                                <div
                                    style={{
                                        background: '#F8FAFC', border: '1.5px solid #3B82F6', borderRadius: 10,
                                        height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                                    }}
                                    onClick={() => setShowModal(true)}
                                >
                                  <span style={{ fontSize: 13, fontWeight: 500, color: '#3B82F6' }}>
                                      + Tambah Pertanyaan
                                  </span>
                                </div>
                            </div>

                            <RightCard stats={form.stats}/>

                        </div>
                }

            </div>
        </div>
    )
}

function Questions({ questions, onDelete }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 16 }}>
            {questions.map((q, qi) => (
                <div key={qi} style={{
                    background: '#F8FAFC', border: '1.5px solid #E2E8F0', borderRadius: 12,
                    overflow: 'hidden', display: 'flex',
                }}>


                    <div style={{ padding: '12px 14px 14px 14px', flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ fontSize: 11, fontWeight: 700, color: '#3B82F6' }}>{`S.${qi + 1}`}</span>
                                <span style={{
                                    background: '#DBEAFE', borderRadius: 11, padding: '2px 10px',
                                    fontSize: 10, fontWeight: 600, color: '#2563EB',
                                }}>Pilihan Ganda</span>
                            </div>


                            <img src={trash} style={{width:16, margin:5,cursor:"pointer"}} alt='' onClick={() => {
                                onDelete(q.id)
                            }}
                            />

                        </div>
                        <p style={{ margin: '0 0 12px', fontSize: 13, fontWeight: 500, color: '#1E293B' }}>{q.question}</p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            {q.choice.map((opt, oi) => (
                                <div key={oi} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <div style={{
                                        width: 12, height: 12, borderRadius: 3, flexShrink: 0,
                                        background: oi === q.correctIndex ? '#16A34A' : '#F1F5F9',
                                        border: oi === q.correctIndex ? 'none' : '1.5px solid #CBD5E1',
                                    }} />
                                    <span style={{
                                        fontSize: 13,
                                        fontWeight: oi === q.correctIndex ? 600 : 400,
                                        color: oi === q.correctIndex ? '#16A34A' : '#64748B',
                                        whiteSpace: 'pre',
                                    }}>{opt.choice}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

function RightCard({stats}) {
    return (
        <div style={{
            background: '#fff', borderRadius: 16, overflow: 'hidden',
            flex: 1, padding: '28px', border: '1px solid #E2E8F0',
        }}>

            <h3 style={{ margin: '0 0 8px', fontSize: 17, fontWeight: 500, color: '#1E293B' }}>Ringkasan Evaluasi</h3>

            <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
                {
                stats.map((stat, i) => (

                    <div key={i} style={{ background: stat.bg, borderRadius: 12, flex: 1, padding: '12px 8px', textAlign: 'center' }}>
                        <p style={{ margin: '0 0 4px', fontSize: 26, fontWeight: 700, color: stat.color }}>{stat.value}</p>
                        <p style={{ margin: 0, fontSize: 10, color: '#64748B' }}>{stat.label}</p>
                    </div>
                ))}
            </div>

            <div style={{ height: 1, background: '#E2E8F0', marginBottom: 16 }} />

            <h4 style={{ margin: '0 0 4px', fontSize: 14, fontWeight: 600, color: '#1E293B' }}>Cara Membuat Pertanyaan</h4>
            <p style={{ margin: '0 0 16px', fontSize: 11, color: '#94A3B8' }}>Panduan cepat menambah satu pertanyaan baru:</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {[
                    { num: '1', title: 'Klik "+ Tambah Pertanyaan"', desc: 'Tombol di kanan atas bagian Daftar Pertanyaan.' },
                    { num: '2', title: 'Pilih tipe pertanyaan', desc: 'Pilihan Ganda, Isian Singkat, atau Skala Likert.' },
                    { num: '3', title: 'Tulis teks pertanyaan', desc: 'Isi pertanyaan lalu tandai jawaban yang benar.' },
                ].map((step, i) => (
                    <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                        <div style={{
                            width: 24, height: 24, borderRadius: 12, background: '#EFF6FF',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                        }}>
                            <span style={{ fontSize: 11, fontWeight: 700, color: '#3B82F6' }}>{step.num}</span>
                        </div>
                        <div>
                            <p style={{ margin: '0 0 2px', fontSize: 12, fontWeight: 600, color: '#1E293B' }}>{step.title}</p>
                            <p style={{ margin: 0, fontSize: 11, color: '#64748B' }}>{step.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BuatSoal

